import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Renders one JSON section (e.g. PCBTestLogs) as an accordion of its
// entries, so a section holding multiple log files/records is browsable
// without dumping everything on screen at once.
const DeviceJsonSectionAccordion = ({ section }) => {
  const entries = section && typeof section === "object" ? Object.entries(section) : [];

  if (entries.length === 0) {
    return <p className="device-json-details_empty">No data available</p>;
  }

  return (
    <div className="device-json-details_accordion-group">
      {entries.map(([key, value]) => (
        <Accordion key={key} disableGutters square className="device-json-details_accordion">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <span className="device-json-details_accordion-title">{key}</span>
          </AccordionSummary>
          <AccordionDetails>
            <pre className="device-json-details_pre">
              {typeof value === "string" ? value : JSON.stringify(value, null, 2)}
            </pre>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default DeviceJsonSectionAccordion;
